
import api from '~api'
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "feeProjectList",
components: {
XHeader
},
data() {
return {
unpaidList: [],
paidList: [],
loaded: false
}
},
mounted() {
this.getData()
},
methods: {
backHome() {
this.$router.push({name: 'home'})
},
getData() {
var stuCode = window.localStorage.getItem("stuCode");
var grade = window.localStorage.getItem("grade");
api.post('/app/feeProject/queryAvailableList', {stuCode: stuCode, grade: grade}).then(res => {
if (res.data.code === 0) {
var list = res.data.data || [];
if (list.length <= 0) {
this.loaded = true;
this.$msgbox('温馨提示：', "暂无可缴费信息");
} else {
this.unpaidList = list.filter(function(item) { return !item.paid; });
this.paidList = list.filter(function(item) { return item.paid; });
this.loaded = true;
}
} else {
this.$msgbox('温馨提示：', res.data.msg || "查询失败");
}
}).catch(() => {
this.loaded = true;
})
},
gotoPay(item) {
this.$router.push({name: 'feeProjectDetail', params: {stunum: window.localStorage.getItem("stuCode"), detail: item}});
},
formatTime(time) {
if (!time) return '';
if (typeof time === 'number') {
var d = new Date(time);
var y = d.getFullYear();
var m = (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1);
var day = (d.getDate() < 10 ? '0' : '') + d.getDate();
return y + '-' + m + '-' + day;
}
return String(time).substring(0, 10);
}
}
}



// WEBPACK FOOTER //
// ./src/components/fee-project/FeeProjectList.vue